import AttentionIcon from '@/icons/attention.svg?react';

export const SellerCOAInfoBlock = () => {
  return (
    <div className='rounded-lg border p-2'>
      <div className='flex-items-center mb-2 font-semibold'>
        <AttentionIcon className='mr-2 shrink-0' />
        Informationen
      </div>
      <div className='mb-4 text-gray-700'>
        Die Liste der Kanäle wird basierend auf Ihren Daten erstellt.
      </div>
      <div className='text-gray-700'>
        Alle Daten, die von Kanälen empfangen werden, die nicht in der Liste
        aufgeführt sind, werden dem Standardkonto zugeordnet.
      </div>
    </div>
  );
};
